export const policyGroups = [
  {
    title: "Shopping & Orders",
    links: [
      { label: "Shipping & Delivery", to: "/shipping" },
      { label: "Returns & Replacements", to: "/returns" },
      { label: "Orders & Cancellations", to: "/orders" },
      { label: "Payment & Billing", to: "/payments" },
      { label: "Pricing & Promotions", to: "/pricing" },
      { label: "International Orders", to: "/international" },
    ],
  },
  {
    title: "Privacy & Trust",
    links: [
      { label: "Privacy Policy", to: "/privacy" },
      { label: "Your Privacy Choices", to: "/privacy-choices" },
      { label: "Cookie Policy", to: "/cookies" },
      { label: "Secure Shopping", to: "/security" },
      { label: "Accessibility", to: "/accessibility" },
    ],
  },
  {
    title: "Products & Legal",
    links: [
      { label: "Product Safety & Allergens", to: "/product-safety" },
      { label: "Product Recalls", to: "/recalls" },
      { label: "Satisfaction Guarantee", to: "/guarantee" },
      { label: "Terms & Conditions", to: "/terms" },
      { label: "Acceptable Use", to: "/acceptable-use" },
      { label: "Intellectual Property & Legal", to: "/legal" },
      { label: "Complaints & Disputes", to: "/complaints" },
    ],
  },
];

export const allPolicyLinks = policyGroups.flatMap((group) => group.links);

